export class LpcuStatusUpdatedNotificationDifferences
{
    public ActualValue: number;
    public ExpectedValue: number;
    public Item: string;

    constructor(json: any = null)
    {
        if (json)
        {
            Object.assign(this, json);
        }
    }
}
